/* ============================================================
   PLANTILLA OREGANO · comportamiento compartido
   Carruseles, galería, cuenta atrás y vídeos.
   Se reinicializa solo al recargar secciones en el editor de Shopify.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- carruseles con flechas y puntos ---------- */
  function initRail(root) {
    root.querySelectorAll('[data-a-rail]').forEach(function (btn) {
      if (btn.dataset.aBound) return;
      btn.dataset.aBound = '1';
      btn.addEventListener('click', function () {
        var rail = root.querySelector('[data-a-rail-id="' + btn.dataset.aRail + '"]');
        if (!rail) return;
        var first = rail.firstElementChild;
        var gap = parseFloat(getComputedStyle(rail).columnGap) || 12;
        var step = first ? first.getBoundingClientRect().width + gap : 220;
        rail.scrollBy({ left: step * Number(btn.dataset.aDir), behavior: 'smooth' });
      });
    });

    root.querySelectorAll('[data-a-rail-id]').forEach(function (rail) {
      if (rail.dataset.aBound) return;
      rail.dataset.aBound = '1';
      var dots = root.querySelector('[data-a-dots="' + rail.dataset.aRailId + '"]');
      if (!dots) return;
      rail.addEventListener('scroll', function () {
        var first = rail.firstElementChild;
        if (!first) return;
        var gap = parseFloat(getComputedStyle(rail).columnGap) || 12;
        var i = Math.round(rail.scrollLeft / (first.getBoundingClientRect().width + gap));
        dots.querySelectorAll('i').forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
      }, { passive: true });
    });
  }


  /* ---------- ¿el visitante pidió menos movimiento? ---------- */
  function sinMovimiento() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* ---------- aparecer al bajar (camino de la evolución) ---------- */
  function initReveal(root) {
    root.querySelectorAll('[data-a-reveal]').forEach(function (el) {
      if (el.dataset.aBound) return;
      el.dataset.aBound = '1';
      if (sinMovimiento() || !('IntersectionObserver' in window)) { el.classList.add('is-in'); return; }
      var obs = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          obs.unobserve(e.target);
        });
      }, { threshold: 0.2 });
      obs.observe(el);
    });
  }

  /* ---------- cifras que suben hasta su valor ---------- */
  function leeNumero(texto) {
    var m = texto.match(/-?\d[\d.,]*/);
    if (!m) return null;
    var crudo = m[0];
    // un punto o coma con una o dos cifras al final es decimal; el resto son millares
    var dec = crudo.match(/[.,](\d{1,2})$/);
    var entero = dec ? crudo.slice(0, -dec[0].length) : crudo;
    var grupo = entero.match(/[.,]/);
    return {
      antes: texto.slice(0, m.index),
      despues: texto.slice(m.index + crudo.length),
      valor: parseFloat(entero.replace(/[.,]/g, '') + (dec ? '.' + dec[1] : '')),
      decimales: dec ? dec[1].length : 0,
      sepDec: dec ? dec[0][0] : '.',
      sepMil: grupo ? grupo[0] : ''
    };
  }

  function escribeNumero(n, f) {
    var s = f.decimales ? n.toFixed(f.decimales) : String(Math.round(n));
    var partes = s.split('.');
    if (f.sepMil) partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, f.sepMil);
    return f.antes + partes[0] + (partes[1] ? f.sepDec + partes[1] : '') + f.despues;
  }

  function initCount(root) {
    root.querySelectorAll('[data-a-count]').forEach(function (el) {
      if (el.dataset.aBound) return;
      el.dataset.aBound = '1';
      // el texto puede ir envuelto en un span con color o tamaño propios
      var destino = el.querySelector('span') || el;
      var f = leeNumero(destino.textContent);
      if (!f || isNaN(f.valor)) return;
      if (sinMovimiento() || !('IntersectionObserver' in window)) return;

      var obs = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting) return;
          obs.unobserve(e.target);
          var t0 = null, dura = 900;
          function paso(t) {
            if (t0 === null) t0 = t;
            var p = Math.min((t - t0) / dura, 1);
            var suave = 1 - Math.pow(1 - p, 3);   // frena al final
            destino.textContent = escribeNumero(f.valor * suave, f);
            if (p < 1) requestAnimationFrame(paso);
          }
          destino.textContent = escribeNumero(0, f);
          requestAnimationFrame(paso);
        });
      }, { threshold: 0.35 });
      obs.observe(el);
    });
  }


  /* ---------- pulsar la valoración baja hasta las reseñas ---------- */
  function initScroll(root) {
    root.querySelectorAll('[data-a-scroll]').forEach(function (a) {
      if (a.dataset.aBound) return;
      a.dataset.aBound = '1';
      a.addEventListener('click', function (e) {
        var destino = document.querySelector(a.getAttribute('href') || '');
        if (!destino) return;                       // sin destino, se deja al navegador
        e.preventDefault();
        destino.scrollIntoView({ behavior: sinMovimiento() ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  /* ---------- galería de producto ---------- */
  function initGallery(root) {
    root.querySelectorAll('[data-a-gallery]').forEach(function (gal) {
      if (gal.dataset.aBound) return;
      gal.dataset.aBound = '1';
      var slides = gal.querySelectorAll('[data-a-slide]');
      var thumbs = gal.querySelectorAll('[data-a-thumb]');
      if (!slides.length) return;
      var actual = 0;

      function show(i) {
        if (i < 0) { i = slides.length - 1; }
        if (i >= slides.length) { i = 0; }
        actual = i;
        slides.forEach(function (s, n) { s.classList.toggle('is-on', n === i); });
        thumbs.forEach(function (t, n) {
          t.classList.toggle('is-on', n === i);
          t.setAttribute('aria-current', n === i ? 'true' : 'false');
        });
        // la miniatura activa entra en vista si la tira tiene scroll
        var act = thumbs[i];
        if (act && act.parentNode && act.parentNode.scrollWidth > act.parentNode.clientWidth) {
          act.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'smooth' });
        }
      }

      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () { show(i); });
      });

      // deslizar con el dedo sobre la imagen grande
      var zona = gal.querySelector('.a-gal__main') || gal;
      var x0 = null, y0 = null;
      zona.addEventListener('touchstart', function (e) {
        x0 = e.changedTouches[0].clientX;
        y0 = e.changedTouches[0].clientY;
      }, { passive: true });
      zona.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        var dy = e.changedTouches[0].clientY - y0;
        // solo si el gesto es claramente horizontal, para no robar el scroll vertical
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          show(dx < 0 ? actual + 1 : actual - 1);
        }
        x0 = null; y0 = null;
      }, { passive: true });
    });
  }

  /* ---------- cuenta atrás perpetua ---------- */
  function initCountdown(root) {
    root.querySelectorAll('[data-a-countdown]').forEach(function (el) {
      if (el.dataset.aBound) return;
      el.dataset.aBound = '1';

      var hours = parseFloat(el.dataset.aCountdown) || 24;
      var total = Math.max(60, Math.round(hours * 3600));
      var key = 'anelvia-cd-' + (el.dataset.aKey || 'default');
      var end;

      try {
        var saved = parseInt(localStorage.getItem(key), 10);
        if (saved && saved > Date.now()) { end = saved; }
      } catch (e) { /* modo privado: se usa una cuenta atrás de sesión */ }

      if (!end) {
        end = Date.now() + total * 1000;
        try { localStorage.setItem(key, String(end)); } catch (e) {}
      }

      var out = {
        h: el.querySelector('[data-a-cd="h"]'),
        m: el.querySelector('[data-a-cd="m"]'),
        s: el.querySelector('[data-a-cd="s"]')
      };
      var pad = function (n) { return n < 10 ? '0' + n : String(n); };

      function tick() {
        var left = Math.floor((end - Date.now()) / 1000);
        if (left <= 0) {                       // al agotarse vuelve a empezar
          end = Date.now() + total * 1000;
          try { localStorage.setItem(key, String(end)); } catch (e) {}
          left = total;
        }
        if (out.h) out.h.textContent = pad(Math.floor(left / 3600));
        if (out.m) out.m.textContent = pad(Math.floor((left % 3600) / 60));
        if (out.s) out.s.textContent = pad(left % 60);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- tarjetas de vídeo ---------- */
  function initVideos(root) {
    root.querySelectorAll('[data-a-video]').forEach(function (card) {
      if (card.dataset.aBound) return;
      card.dataset.aBound = '1';
      card.addEventListener('click', function () {
        var v = card.querySelector('video');
        if (!v) return;
        var play = card.querySelector('.a-play');
        // el navegador solo arranca solo sin sonido: el primer toque lo devuelve
        if (v.muted && !v.paused) { v.muted = false; return; }
        if (v.paused) { v.play(); if (play) play.style.display = 'none'; }
        else { v.pause(); if (play) play.style.display = ''; }
      });

      // con arranque automático, cada vídeo se reproduce solo mientras está a la vista
      var v0 = card.querySelector('video');
      if (v0 && v0.autoplay && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entradas) {
          entradas.forEach(function (e) {
            if (e.isIntersecting) { var r = v0.play(); if (r && r.catch) r.catch(function () {}); }
            else { v0.pause(); }
          });
        }, { threshold: 0.5 }).observe(card);
      }
    });
  }

  /* ---------- selector de packs ---------- */
  function initBundles(raiz) {
    raiz.querySelectorAll('.a-bundle').forEach(function (b) {
      if (b.dataset.aBound) return;
      b.dataset.aBound = '1';
      b.addEventListener('click', function () {
        b.parentNode.querySelectorAll('.a-bundle').forEach(function (x) { x.classList.remove('is-on'); });
        b.classList.add('is-on');
      });
    });
  }

  /* ---------- acordeón: solo uno abierto a la vez ---------- */
  function initAccordion(root) {
    root.querySelectorAll('[data-a-accordion]').forEach(function (grupo) {
      if (grupo.dataset.aBound) return;
      grupo.dataset.aBound = '1';
      var filas = grupo.querySelectorAll('details');
      filas.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          filas.forEach(function (otra) { if (otra !== d) { otra.open = false; } });
        });
      });
    });
  }

  function initAll(root) {
    root = root || document;
    initRail(root);
    initGallery(root);
    initAccordion(root);
    initCountdown(root);
    initReveal(root);
    initCount(root);
    initScroll(root);
    initVideos(root);
    initBundles(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* el editor de Shopify recarga secciones sueltas */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
